import { render, staticRenderFns } from "./CookieChecker.vue?vue&type=template&id=0f8813a6&scoped=true&lang=pug&"
import script from "./CookieChecker.vue?vue&type=script&lang=js&"
export * from "./CookieChecker.vue?vue&type=script&lang=js&"
import style0 from "./CookieChecker.vue?vue&type=style&index=0&id=0f8813a6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f8813a6",
  null
  
)

export default component.exports